import React from "react";
import lazyPage from "../../../common/helpers/lazyPage";
import PageLoader from "../../components/PageLoader";

export default lazyPage(
    "src/front/pages/signup/signup.tsx",
    () => import("./signup"),
    <PageLoader />,
);
